// pc
import mizhouFm from '@/assets/img/pc/mizhou/fengmian.png'
import mizhou1 from '@/assets/img/pc/mizhou/1.png'
import mizhou2 from '@/assets/img/pc/mizhou/2.png'
import mizhou3 from '@/assets/img/pc/mizhou/3.png'
import xhLabrcFm from '@/assets/img/pc/xhLabrc/fengmian.png'
import xhLabrc1 from '@/assets/img/pc/xhLabrc/1.png'
import xhPcFm from '@/assets/img/pc/xhPc/fengmian.png'
import xhPc1 from '@/assets/img/pc/xhPc/1.png'
import xhPc2 from '@/assets/img/pc/xhPc/2.png'
import xhPc3 from '@/assets/img/pc/xhPc/3.png'
import xhPc4 from '@/assets/img/pc/xhPc/4.png'
import sichuanFm from '@/assets/img/pc/sichuan/fengmian.jpg'
import sichuan1 from '@/assets/img/pc/sichuan/1.png'
import sichuan2 from '@/assets/img/pc/sichuan/2.png'
import sichuan3 from '@/assets/img/pc/sichuan/3.png'
import sichuan4 from '@/assets/img/pc/sichuan/4.png'
import fuzhuFm from '@/assets/img/pc/fuzhu/fengmian.jpg'
import fuzhu1 from '@/assets/img/pc/fuzhu/1.jpg'
import fuzhu2 from '@/assets/img/pc/fuzhu/2.jpg'
import fuzhu3 from '@/assets/img/pc/fuzhu/3.jpg'
import fuzhu4 from '@/assets/img/pc/fuzhu/4.jpg'
import fuzhu5 from '@/assets/img/pc/fuzhu/5.jpg'
import baiseFm from '@/assets/img/pc/baise/fengmian.jpg'
import baise1 from '@/assets/img/pc/baise/1.jpg'
import baise2 from '@/assets/img/pc/baise/2.png'
import baise3 from '@/assets/img/pc/baise/3.png'
import adminFm from '@/assets/img/pc/admin/fengmian.png'
import admin1 from '@/assets/img/pc/admin/1.png'
import admin3 from '@/assets/img/pc/admin/3.png'
import admin4 from '@/assets/img/pc/admin/4.png'
import admin5 from '@/assets/img/pc/admin/5.png'
import admin6 from '@/assets/img/pc/admin/6.png'
import admin7 from '@/assets/img/pc/admin/7.png'
import admin8 from '@/assets/img/pc/admin/8.png'
import admin9 from '@/assets/img/pc/admin/9.png'
import admin10 from '@/assets/img/pc/admin/10.png'
import admin11 from '@/assets/img/pc/admin/11.png'
import admin12 from '@/assets/img/pc/admin/12.png'
import admin13 from '@/assets/img/pc/admin/13.png'
import admin14 from '@/assets/img/pc/admin/14.png'

// h5
import xhH5Fm from '@/assets/img/h5/xh/fengmian.png'
import xhMobile1 from '@/assets/img/h5/xh/1.png'
import xhMobile2 from '@/assets/img/h5/xh/2.png'
import xhMobile3 from '@/assets/img/h5/xh/3.png'
import xhMobile4 from '@/assets/img/h5/xh/4.png'
import xhMobile5 from '@/assets/img/h5/xh/5.png'
import xhMobile6 from '@/assets/img/h5/xh/6.png'
import xhMobile7 from '@/assets/img/h5/xh/7.png'
import pingtanFm from '@/assets/img/h5/pingtan/fengmian.png'
import pingtan1 from '@/assets/img/h5/pingtan/1.png'
import pingtan2 from '@/assets/img/h5/pingtan/2.png'
import pingtan3 from '@/assets/img/h5/pingtan/3.png'
import pingtan4 from '@/assets/img/h5/pingtan/4.png'
import pingtan5 from '@/assets/img/h5/pingtan/5.png'
import pingtan6 from '@/assets/img/h5/pingtan/6.png'
import pingtan7 from '@/assets/img/h5/pingtan/7.png'
import zikaoFm from '@/assets/img/h5/zikao/fengmian.png'
import zikao1 from '@/assets/img/h5/zikao/1.png'
import zikao2 from '@/assets/img/h5/zikao/2.png'
import zikao3 from '@/assets/img/h5/zikao/3.png'
import zikao4 from '@/assets/img/h5/zikao/4.png'
import zikao5 from '@/assets/img/h5/zikao/5.png'
import zikao6 from '@/assets/img/h5/zikao/6.png'
import mallFm from '@/assets/img/h5/mall/fengmian.jpg'
import mall1 from '@/assets/img/h5/mall/1.jpg'
import mall2 from '@/assets/img/h5/mall/2.jpg'
import mall3 from '@/assets/img/h5/mall/3.jpg'
import mall4 from '@/assets/img/h5/mall/4.jpg'
import mall5 from '@/assets/img/h5/mall/5.jpg'
import mall6 from '@/assets/img/h5/mall/6.jpg'
import mall7 from '@/assets/img/h5/mall/7.jpg'
import signFm from '@/assets/img/h5/sign/fengmian.jpg'
import sign1 from '@/assets/img/h5/sign/1.jpg'
import sign2 from '@/assets/img/h5/sign/2.jpg'
import sign3 from '@/assets/img/h5/sign/3.jpg'
import sign4 from '@/assets/img/h5/sign/4.jpg'
import sign5 from '@/assets/img/h5/sign/5.jpg'
import sign6 from '@/assets/img/h5/sign/6.jpg'
import chevroletFm from '@/assets/img/h5/chevrolet/fengmian.jpg'
import chevrolet1 from '@/assets/img/h5/chevrolet/1.jpg'
import chevrolet2 from '@/assets/img/h5/chevrolet/2.jpg'
import chevrolet3 from '@/assets/img/h5/chevrolet/3.jpg'
import chevrolet4 from '@/assets/img/h5/chevrolet/4.jpg'
import bottleFm from '@/assets/img/h5/bottle/fengmian.jpg'
import bottle1 from '@/assets/img/h5/bottle/1.jpg'
import bottle2 from '@/assets/img/h5/bottle/2.jpg'
import bottle3 from '@/assets/img/h5/bottle/3.jpg'
import bottle4 from '@/assets/img/h5/bottle/4.jpg'
import bottle5 from '@/assets/img/h5/bottle/5.jpg'
import priceFm from '@/assets/img/h5/price/fengmian.jpg'
import price1 from '@/assets/img/h5/price/1.jpg'
import price2 from '@/assets/img/h5/price/2.gif'
import price3 from '@/assets/img/h5/price/3.png'
import price4 from '@/assets/img/h5/price/4.jpg'
import avenirFm from '@/assets/img/h5/avenir/fengmian.jpg'
import avenir1 from '@/assets/img/h5/avenir/1.jpg'
import avenir2 from '@/assets/img/h5/avenir/2.jpg'
import avenir3 from '@/assets/img/h5/avenir/3.jpg'
import avenir4 from '@/assets/img/h5/avenir/4.jpg'
import avenir5 from '@/assets/img/h5/avenir/5.jpg'

import foshanFm from '@/assets/img/miniProgram/foshan/fengmian.jpg'
import foshan1 from '@/assets/img/miniProgram/foshan/1.jpg'
import foshan2 from '@/assets/img/miniProgram/foshan/2.jpg'
import foshan3 from '@/assets/img/miniProgram/foshan/3.jpg'
import foshan4 from '@/assets/img/miniProgram/foshan/4.jpg'
import foshan5 from '@/assets/img/miniProgram/foshan/5.png'
import foshan6 from '@/assets/img/miniProgram/foshan/6.jpg'

import zhihuanFm from '@/assets/img/miniProgram/zhihuan/fengmian.jpg'
import zhihuan1 from '@/assets/img/miniProgram/zhihuan/1.jpg'
import zhihuan2 from '@/assets/img/miniProgram/zhihuan/2.png'
import zhihuan3 from '@/assets/img/miniProgram/zhihuan/3.png'
import zhihuan4 from '@/assets/img/miniProgram/zhihuan/4.jpg'
import zhihuan5 from '@/assets/img/miniProgram/zhihuan/5.jpg'
import zhihuan6 from '@/assets/img/miniProgram/zhihuan/6.jpg'


export const tabItems = [
    { 
      key: '1', 
      title: 'PC端', 
      content: [
        { id: 'pc1', img: mizhouFm, title: 'NextJs全栈网站', info: 'NextJs+Ts+Tailwind' },
        { id: 'pc2', img: xhLabrcFm, title: '项目组公共组件库', info: 'Dumi库+React' },
        { id: 'pc3', img: xhPcFm, title: '实验室管理系统', info: 'Umi+Antd+Ts' },
        { id: 'pc4', img: sichuanFm, title: '四川演示', info: 'React+Redux+Antd+Tailwind' },
        { id: 'pc5', img: fuzhuFm, title: '辅助决策数据大屏', info: 'Vue+Element+Ts+Echarts' },
        { id: 'pc6', img: baiseFm, title: '百色录取大屏', info: 'Vue全家桶+Element' },
        { id: 'pc7', img: adminFm, title: '后台管理系统案例', info: 'Vue全家桶+Element' }
      ]
    },
    { 
      key: '2', 
      title: '移动端H5', 
      content: [
        { id: 'mobile0', img: xhH5Fm, title: '实验室管理系统移动端', info: 'Umi+Antd-Mobile+Ts' },
        { id: 'mobile1', img: pingtanFm, title: '平潭入学招生', info: 'Vue3+Vite+Vuex+Vant+Ts' },
        { id: 'mobile2', img: zikaoFm, title: '合肥自考学生端', info: 'UniApp+Uview-ui' },
        { id: 'mobile4', img: signFm, title: '打卡签到', info: 'Vue全家桶' },
        { id: 'mobile5', img: chevroletFm, title: '聚乐会', info: 'Vue+webpack' },
        { id: 'mobile6', img: bottleFm, title: '漂流瓶', info: 'Vue全家桶' },
        { id: 'mobile8', img: avenirFm, title: 'avenir租车', info: 'Vue全家桶' },
        { id: 'mobile3', img: mallFm, title: '微信商城', info: 'JS模板引擎+JQuery+Gulp' },
        { id: 'mobile7', img: priceFm, title: '砍价活动', info: 'JS模板引擎+JQuery' },
      ]
    },
    { 
      key: '3', 
      title: '微信小程序', 
      content: [
        { id: 'program1', img: zhihuanFm, title: '爱车回收红利卡置换', info: '微信小程序原生' },
        { id: 'program2', img: foshanFm, title: '佛山中招小程序', info: 'UniApp+Vue' },
      ]
    }
  ]

export const previewImgs: any = {
  pc1: [mizhouFm,mizhou1,mizhou2,mizhou3,],
  pc2: [xhLabrcFm, xhLabrc1],
  pc3: [xhPcFm, xhPc1, xhPc2, xhPc3, xhPc4],
  pc4: [sichuan1,sichuan2,sichuan3,sichuan4],
  pc5: [fuzhu1,fuzhu2,fuzhu3,fuzhu4,fuzhu5],
  pc6: [baise1,baise2,baise3],
  pc7: [admin1,admin3,admin4,admin5,admin6,admin7,admin8,admin9,admin10,admin11,admin12,admin13,admin14],
  mobile0: [xhH5Fm, xhMobile1, xhMobile2, xhMobile3, xhMobile4,xhMobile5,xhMobile6,xhMobile7,],
  mobile1: [pingtan1,pingtan2,pingtan3,pingtan4,pingtan5,pingtan6,pingtan7],
  mobile2: [zikao1,zikao2,zikao3,zikao4,zikao5,zikao6],
  mobile3: [mall1,mall2,mall3,mall4,mall5,mall6,mall7],
  mobile4: [sign1,sign2,sign3,sign4,sign5,sign6],
  mobile5: [chevrolet1,chevrolet2,chevrolet3,chevrolet4],
  mobile6: [bottle1,bottle2,bottle3,bottle4,bottle5],
  mobile7: [price1,price2,price3,price4],
  mobile8: [avenir1,avenir2,avenir3,avenir4,avenir5],
  program1: [zhihuan1, zhihuan2, zhihuan3, zhihuan4, zhihuan5, zhihuan6],
  program2: [foshan1, foshan2, foshan3, foshan4, foshan5, foshan6],
}